import React, { useState, useEffect } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import * as actions from "../../src/actions";
// 3rd party libs.
import ReactHtmlParser from "react-html-parser";

// Material-UI
import {
  Button,
  IconButton,
  makeStyles,
  MobileStepper,
  useTheme,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

// Custom Comp.
import Navbar from "../components/navbar/navbar.component";
import CinemaDraftButton from "../components/cinema-draft-button/cinema-draft-button.component";
import Footer from "../components/footer/footer.component";

// Images
import ArrowInButton from "../public/herosection-button-icon.svg";
import LogoCyan from "../public/CETO-icon-cyan.svg";
import WisdomIllustration from "../public/wisdom-section-illustration.jpg";
import LoyaltySectionIllustration from "../public/loyalty-section-illustration.svg";
import TwitterIcon from "../public/twitter-icon.svg";
import DiscordIcon from "../public/discord-icon.svg";
import TelegramIcon from "../public/telegram-icon.svg";
import Elephant from "../public/hero-section-elephant.svg";
import convo from "../public/convo.png";
import arrow2 from "../public/Button - Icon.svg";
// Mapped Data for landing page
import QUESTIONS_ARRAY from "./../assets/landing/questions";
import chat from "../public/chat_.png";
// Stylesheets
import "../styles/Landing.scss";
import getWeb3 from "../getWeb3";
import Contract_obj from "../getTronweb.js";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";

const Landing = props => {
  const [questionsArray, setQuestionsArray] = useState(QUESTIONS_ARRAY);
  const [activeCase, setCase] = useState(2);
  const [timer, setTimer] = useState();
  const [live, setLive] = useState(false);


  // Function which toggles the question & answers
  const toggleQA = (e, idx) => {
    setQuestionsArray(questionsArray => {
      const dummyArr = questionsArray;

      dummyArr[idx].isOpen = !dummyArr[idx].isOpen;

      return [...dummyArr];
    });
  };

  useEffect(() => {
    const offset = 48600;
    const end_timestamp = 1612393200;

    var x = setInterval(function () {
      // Get today's date and time
      const currentDate = new Date();
      const now = parseInt(currentDate.getTime().toString().slice(0, -3));

      // Find the distance between now and the count down date
      var distance = end_timestamp - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (60 * 60 * 24));
      var hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
      var minutes = Math.floor((distance % (60 * 60)) / 60);
      var seconds = Math.floor(distance % 60);

      // Display the result in the element with id="demo"
      setTimer({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      });

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        setTimer()
        setLive(true)
      }
    }, 1000);

    console.log(props.match.params.ref_name , "props")
    if(props.match.params.ref_name){
      localStorage.setItem("ref_name" , props.match.params.ref_name)
    }
  }, []);

  const nextCase = () => {
    var step = activeCase == 4 ? 5 : (activeCase + 1) % 5;
    setCase(step);
  };
  const prevCase = () => {
    var step = activeCase == 1 ? 5 : (activeCase - 1) % 5;
    setCase(step);
  };
  return (
    <div className="landingContainer">
      {/* Navbar and Hero Section */}
      <div className="navAndHeroSection">
        {/* Navbar */}
        <Navbar {...props} homepage={true} page={1} />

        {/* Hero Section */}
        <div className="navAndHeroSection__hero">
          <span>
            <b>TRON…</b> <i>is good</i>
          </span>

          <CinemaDraftButton
            style={{ background: "#A53CFF" }}
            onClick={() => props.history.replace({ pathname: "exchange" })}
          >
            Exchange
            <img alt="landing_imgs" src={ArrowInButton} width="20px" />
          </CinemaDraftButton>

          <span>
            <span>Beat the Herd</span>
            
            {timer && (
              <span>
                <span>
                  {timer &&
                    (timer.days < 10
                      ? String(timer.days).padStart(2, "0")
                      : timer.days)}{" "}
                  <sub className="unit">D</sub>
                </span>

                <span>
                  {timer &&
                    (timer.hours < 10
                      ? String(timer.hours).padStart(2, "0")
                      : timer.hours)}{" "}
                  <sub className="unit">H</sub>
                </span>

                <span>
                  {timer &&
                    (timer.minutes < 10
                      ? String(timer.minutes).padStart(2, "0")
                      : timer.minutes)}
                  <sub className="unit" style={{ marginLeft: "5px" }}>
                    M
                  </sub>
                </span>
                <span>
                  {timer &&
                    (timer.seconds < 10
                      ? String(timer.seconds).padStart(2, "0")
                      : timer.seconds)}
                  <sub className="unit" style={{ marginLeft: "5px" }}>
                    S
                  </sub>
                </span>
              </span>
            )}
           {live &&  <span className = "live">We are now live!</span>}
          </span>
        </div>
      </div>

      {/* Hello CETO */}
      <div className="helloCETO">
        <span>Hello, CETO</span>
        <img src={chat} style={{ marginTop: "3rem" }} className="convo"></img>
        <img
          src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609997963/cd3d/Group_5158_1_mrjngo.png"
          className="left-img l"
        ></img>
        <img
          src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609997950/cd3d/Group_4069_1_tnm5gn.png"
          className="right-img l"
        ></img>
        <div className="ethinfo">
          <span>
            Trade TRX for tokens. The more TRX in-contract, the more valuable
            your tokens. Pay your taxes (10% per transaction) and watch the
            dividends roll in while you Hold On for Dear Life.
          </span>
          <span>
            The key here is PATIENCE: there are withdrawal penalties without it.
            After 30 days, you’re eligible to extract 100% of your deposit. But
            before then? Learn to live with much, much less.
          </span>
        </div>

        <span>See the Elephant, BE the Elephant - in every room.</span>
      </div>

      {/* Saddle Up */}
      <div className="saddleUp">
        <div>
          <span>Saddle Up</span>
          <CinemaDraftButton
            className="webshow"
            onClick={() => {
              props.history.replace({ pathname: "/whitepaper" });
            }}
            style={{ background: "#fff", color: "#002E8C", marginTop: "1.2em" }}
          >
            Whitepaper
            <img alt="landing_imgs" src={ArrowInButton} width="20px" />
          </CinemaDraftButton>
        </div>

        <div className="id">
          <span>
            <img alt="landing_imgs" src={LogoCyan} />
            Exchange TRX for CETO through your TronLink or compatible web
            wallet. It’s not as hard as you think.
          </span>
          <span>
            <img alt="landing_imgs" src={LogoCyan} />
            Every time someone buys CETO with TRX, the price of CETO goes up.
            Every time someone sells CETO for TRX, the price goes down.
          </span>
          <span>
            <img alt="landing_imgs" src={LogoCyan} />
            When someone makes a transaction of any kind, 10% is taken out and
            distributed proportionally as dividends to EVERY tokenholder alike.
          </span>
          <span>
            <img alt="landing_imgs" src={LogoCyan} />
            Leave whenever you want. Just know if it’s within 30 days of your
            deposit, it’ll cost you:
          </span>
          <ul>
            <li>sell 0-9 days, -75% principal value</li>
            <li>sell 10-19 days, -50% principal value</li>
            <li>sell 20-29 days, -25% principal value</li>
            <li>
              sell 30+ days, <b>receive 100% of your principal value</b>
            </li>
          </ul>
        </div>
        <div className="mobileshow">
          <CinemaDraftButton
            onClick={() => {
              props.history.replace({ pathname: "/whitepaper" });
            }}
            style={{ background: "#fff", color: "#002E8C", marginTop: "1.2em" }}
          >
            Whitepaper
            <img alt="landing_imgs" src={arrow2} width="20px" />
          </CinemaDraftButton>
        </div>
      </div>

      {/* Hourglass */}
      <div className="hourglass">
        <span>The Hourglass that Lasts</span>

        <span>
          Much like commercial food service, CETO operates on the FIFO system:
          first in, first out. If you make a deposit Day 1 and then redeposit or
          reinvest your dividends on Day 15, then only the amount you deposited
          on Day 1 will be 100% available to withdraw <b>after 30 days.</b>
        </span>

        <div className="hourglass__timeline l">
          <span
            onClick={() => setCase(2)}
            className={`case ${activeCase == 2 ? "active_case" : ""}`}
          >
            Probable
          </span>
          <span
            onClick={() => setCase(3)}
            className={`case ${activeCase == 3 ? "active_case" : ""}`}
          >
            Likely
          </span>
          <span
            onClick={() => setCase(4)}
            className={`case ${activeCase == 4 ? "active_case" : ""}`}
          >
            Less Likely
          </span>
          <span
            onClick={() => setCase(5)}
            className={`case ${activeCase == 5 ? "active_case" : ""}`}
          >
            Unlikely
          </span>
        </div>
        <div className="hourglass__timeline s">
          <IconButton aria-label="delete" onClick={() => prevCase()}>
            <img src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609999098/cd3d/Button_-_Icon_1_wi1rzh.png"></img>
          </IconButton>

          <span
            className={`case ${
              activeCase == 2 ? "active_case" : "inactive_case"
            }`}
          >
            Probable
          </span>
          <span
            className={`case ${
              activeCase == 3 ? "active_case" : "inactive_case"
            }`}
          >
            Likely
          </span>
          <span
            className={`case ${
              activeCase == 4 ? "active_case" : "inactive_case"
            }`}
          >
            Less Likely
          </span>
          <span
            className={`case ${
              activeCase == 5 ? "active_case" : "inactive_case"
            }`}
          >
            Unlikely
          </span>
          <IconButton aria-label="delete" onClick={() => nextCase()}>
            <img src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609999134/cd3d/Button_-_Icon_1_dxldkx.png"></img>
          </IconButton>
        </div>
        <span className="sub_head l">
          {activeCase == 2 &&
            "Dividends, Withdrawals, Redeposits, Currency Fluctuations"}
          {activeCase == 3 &&
            "Dividends, No Withdrawals, Redeposits, Currency Fluctuations"}
          {activeCase == 4 &&
            "No Dividends, No Contract growth, Currency Fluctuations"}
          {activeCase == 5 &&
            "No Dividends, No Contract growth, No Currency Fluctuations"}
        </span>

        {activeCase == 2 && (
          <div className="hourglass__dayList">
            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 1</span>
                <span>
                  Exchange 100,000 <b> (current CETO price = 2.36 TRX)</b> for
                  42,341 CETO.
                </span>
                <span>Less 10% transaction fee + dividends reinvested.</span>
                <span>
                  TRX = $0.03 USD.<b> Starting value</b> = $3,000
                </span>
                <span>
                  <b>
                    Balance: 44,426 CETO/100,749 TRX (25% available to withdraw
                    = 11,107 CETO/
                  </b>
                </span>
                <span>
                  <b>34,335 TRX); Dividend Balance: 1,005 TRX.</b>
                </span>
                <span>
                  <b>$3,023 wallet value, $1030 withdrawal value.</b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">
                  Day 12 (reinvested daily for 11 days)
                </span>
                <span>
                  Assume 0.2% daily token dividend rate for{" "}
                  <b>269 TRX. (current CETO price = 2.8 TRX)</b>.
                </span>
                <span>Reinvest 269 TRX. Less 10% transaction fee.</span>
                <span>
                  <b>
                    Balance: 45,148 CETO/126,297 TRX (50% available to withdraw
                    = 22,574 CETO/ 63,149 TRX).
                  </b>
                </span>
                <span>
                  <b>Dividend Balance: 0.</b> TRX = $0.0275 USD.
                </span>
                <span>
                  <b>
                    $3473 wallet value, $0 dividend value, $1737 withdrawal
                    value.
                  </b>
                </span>
              </div>
            </div>

            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">
                  Day 22 (alternated daily reinvestment and withdrawal for 10
                  days):{" "}
                </span>
                <span>
                  Assume 0.2% daily token dividend rate for{" "}
                  <b>295 TRX. (current CETO price = 3.35 TRX)</b>.
                </span>
                <span>Withdraw 295 TRX.</span>
                <span>
                  <b>
                    Balance: 45,330 CETO/151,878 TRX (75% of 33,998 CETO/113,909
                    TRX available to withdraw)
                  </b>
                </span>

                <span>
                  <b>Dividend Balance: 0.</b>TRX = $0.033 USD.
                </span>
                <span>
                  <b>$5012 wallet value, $0 dividend value,</b>
                </span>
                <span>
                  <b>$3759 withdrawal value, $10 withdrawn</b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">
                  Day 31 (daily withdrawals for 10 days):{" "}
                </span>
                <span>
                  Assume 0.2% daily token dividend rate for{" "}
                  <b> 346 TRX. (current CETO price = 3.35 TRX)</b>.
                </span>
                <span>Withdraw 346 TRX.</span>
                <span>
                  <b>
                    Balance: 45,330 CETO/178,174 TRX (100% of 45,330
                    CETO/180,823 TRX available to withdraw) Dividend Balance: 0.
                  </b>{" "}
                  TRX = $0.0375 USD.
                </span>
                <span>
                  <b>
                    $6,682 wallet value, $0 dividend value, $6,781 withdrawal
                    value, $175 withdrawn.
                  </b>
                </span>
                <span>Exchange 45,330 CETO for 180,823 TRX.</span>
                <span>Less 10% transaction fee.</span>
              </div>
            </div>
          </div>
        )}
        {activeCase == 3 && (
          <div className="hourglass__dayList">
            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 1</span>
                <span>
                  Exchange 100,000 <b> (current CETO price = 2.36 TRX)</b> for
                  <b>42,341 CETO.</b>
                </span>
                <span>Less 10% transaction fee.</span>
                <span>
                  TRX = $0.03 USD.<b>Starting value = $3,000</b>
                </span>
                <span>
                  <b>
                    Balance: 42,341 CETO/91,606 TRX (25% available to withdraw =
                    10,585 CETO/ 30,772 TRX)
                  </b>
                </span>
                <span>
                  <b>Dividend Balance: 10,160 TRX.</b>
                </span>
                <span>
                  <b> $2,748 wallet value, $923 withdrawal value.</b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 11</span>
                <span>
                  Assume 0.2% daily token dividend rate for
                  <b> 11,976 TRX. (current CETO price = 2.55 TRX)</b>.
                </span>

                <span>
                  <b>
                    Balance: 42,341 CETO/108,018 TRX (50% available to withdraw
                    = 21,171 CETO/ 60,585 TRX)
                  </b>
                </span>
                <span>
                  <b>Dividend Balance: 11,976 TRX.</b> TRX = $0.0275 USD.
                </span>
                <span>
                  <b>
                    $2971 wallet value, $329 dividend value, $1666 withdrawal
                    value.
                  </b>
                </span>
              </div>
            </div>

            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 21</span>
                <span>
                  Assume 0.2% daily token dividend rate for
                  <b>14,117 TRX. (current CETO price = 3.01 TRX)</b>.
                </span>
                <span>
                  <b>
                    Balance: 42,341 CETO/127,368 TRX (75% available to withdraw
                    = 31,756 CETO/ 100,090 TRX)
                  </b>
                </span>

                <span>
                  <b>Dividend Balance: 14,117 TRX.</b>TRX = $0.033 USD.
                </span>
                <span>
                  <b>
                    $4,203 wallet value, $466 dividend value, $3303 withdrawal
                    value.
                  </b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">
                  Day 31 (daily withdrawals for 10 days):{" "}
                </span>
                <span>
                  Assume 0.2% daily token dividend rate for{" "}
                  <b> 16,639 TRX. (current CETO price = 3.55 TRX)</b>.
                </span>
                <span>
                  <b>
                    Balance: 42,341 CETO/150,177 TRX (100% available to withdraw
                    = 42,341 CETO/150,177 TRX)
                  </b>{" "}
                  TRX = $0.0375 USD.
                </span>
                <span>
                  <b>Dividend Balance: 16,639 CETO/XX TRX.</b>
                </span>
                <span>
                  <b>
                    $5,632 wallet value, $624 dividend value, $5,632 withdrawal
                    value.
                  </b>
                </span>
                <span>
                  Exchange 42,341 CETO + dividends for 166,816 TRX. Less 10%
                  transaction fee.{" "}
                </span>
                <span>Less 10% transaction fee.</span>
              </div>
            </div>
          </div>
        )}
        {activeCase == 4 && (
          <div className="hourglass__dayList">
            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 1</span>
                <span>
                  Exchange 100,000 <b> (current CETO price = 2.36 TRX)</b> for
                  <b>42,341 CETO.</b>
                </span>
                <span>
                  TRX = $0.03 USD. <b>Starting value = $3,000</b>
                </span>
                <span>
                  <b>
                    Balance: 42,341 CETO/89,993 TRX (25% available to withdraw =
                    10,585 CETO/ 30,230 TRX); $2,700 wallet value, $907
                    withdrawal value.
                  </b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 11</span>

                <span>
                  <b>
                    Balance: 42,341 CETO/89,993 TRX (50% available to withdraw =
                    21,171 CETO/ 50,479 TRX),
                  </b>
                </span>
                <span>TRX = $0.0275 USD.</span>
                <span>
                  <b>$2475 wallet value, $1388 withdrawal value.</b>
                </span>
              </div>
            </div>

            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 21</span>

                <span>
                  <b>
                    Balance: 42,341 CETO/89,993 TRX (75% available to withdraw =
                    31,756 CETO/ 70,727 TRX),
                  </b>
                </span>

                <span>TRX = $0.033 USD.</span>
                <span>
                  <b>$2970 wallet value, $2334 withdrawal value.</b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 31</span>

                <span>
                  <b>
                    Balance: 42,341 CETO/90,976 TRX (100% available to withdraw
                    = 42,341 CETO/90,976 TRX),
                  </b>{" "}
                  TRX = $0.0375 USD.
                </span>
                <span>
                  <b>$3412 wallet value, $3412 withdrawal value.</b>
                </span>

                <span>
                  Exchange 42,341 CETO for 90,976 TRX. Less 10% transaction fee.
                </span>
              </div>
            </div>
          </div>
        )}
        {activeCase == 5 && (
          <div className="hourglass__dayList">
            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 1</span>
                <span>
                  Exchange 100,000 <b> (current CETO price = 2.36 TRX)</b> for
                  <b>42,341 CETO.</b>
                </span>

                <span>
                  <b>
                    Balance: 42,341 CETO/89,993 TRX (25% available to withdraw =
                    10,585 CETO/ 30,230 TRX)
                  </b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 11</span>

                <span>
                  <b>
                    Balance: 42,341 CETO/89,993 TRX (50% available to withdraw =
                    21,171 CETO/ 50,479 TRX)
                  </b>
                </span>
              </div>
            </div>

            <div className="hourglass__dayRow">
              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 21</span>

                <span>
                  <b>
                    Balance: 42,341 CETO/89,993 TRX (75% available to withdraw =
                    31,756 CETO/ 70,727 TRX)
                  </b>
                </span>
              </div>

              <div className="hourglass__day">
                <span className="hourglass__dayHeading">Day 31</span>

                <span>
                  <b>
                    Balance: 42,341 CETO/90,976 TRX (100% available to withdraw
                    = 42,341 CETO/90,976 TRX)
                  </b>{" "}
                </span>

                <span>
                  Exchange 42,341 CETO for 90,976 TRX. Less 10% transaction fee.
                </span>
              </div>
            </div>
          </div>
        )}

        <span>Beat the jungle - ride the Elephant</span>

        {activeCase == 2 && (
          <>
            <span>Total Withdrawal: 162,741 TRX, $6,103</span>
            <span>Total Earnings: 167,400 TRX, $6,278 USD</span>
          </>
        )}
        {activeCase == 3 && <span>Total Withdrawal: 166,816 TRX, $6,256</span>}
        {activeCase > 3 && <span>Total: 81,878 TRX, $3070</span>}
      </div>

      {/* Strength */}
      <div className="strength">
        <span>Strength</span>
        <span>
          Get more TRX outta your TRX. Watch its fiat value rise with the
          markets.
        </span>
        <span>
          Dividends are free to withdraw at any time. Compound your principal by
          reinvesting the divs to receive an even greater share of rewards. Sit
          back, relax, and enjoy another 30 days of contract safety.{" "}
          <b>#ElephantStrong</b>
        </span>
        <CinemaDraftButton
          style={{ background: "#009EE4" }}
          onClick={() => props.history.replace({ pathname: "exchange" })}
        >
          Get Started
          <img alt="landing_imgs" src={ArrowInButton} width="20px" />
        </CinemaDraftButton>
      </div>

      {/* Wisdom */}
      <div className="wisdom">
        <span>Wisdom</span>

        <div className="wisdom__content">
          <img alt="landing_imgs" src={WisdomIllustration} />

          <div className="wisdom__contentSliderPart">
            <div className="wisdom__sliderContainer">
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Smart</span>
                <span>
                  Autonomous, trustless, decentralized - the way contracts
                  oughta be.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Fair</span>
                <span>
                  All transactions taxed 10% - and distributed to those savvy
                  tokenholders.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Patient</span>
                <span>
                  If you can’t handle CETO on its tenth day, you don’t deserve
                  it on its thirtieth.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Abundant</span>
                <span>
                  Always there when you need it: no limit on tokens! But the
                  more TRX in the contract, the more expensive the CETO.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Fun</span>
                <span>
                  Everyday is payday. Making money’s still fun around here,
                  right?
                </span>
              </div>
            </div>

            <div className="wisdom__sliderContainer">
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Simple</span>
                <span>
                  Buy or sell tokens, the price goes up/down a little bit more
                  (~.0001 TRX). Easy peasy.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Just</span>
                <span>
                  We buy when you buy - and we’re in this for the long haul.
                  Everyday is someone’s thirtieth day.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Friendly</span>
                <span>
                  Share the wealth and invite some friends! Get your own
                  referral link and enjoy 1/3 of your referrals’ dividends as
                  well.
                </span>
              </div>
              <div className="wisdom__slide">
                <span className="wisdom__slideHeading">Vetted</span>
                <span>
                  Based on the popular P3D open source contract, incentivized
                  for longevity. We didn’t invent the hourglass contract - we
                  just made it better.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Loyalty */}
      <div className="loyalty">
        <span>Loyalty</span>

        <div>
          <div className="loyalty-card">
            <img
              alt="landing_imgs"
              src={LoyaltySectionIllustration}
              width="130"
            />
            <span>Invest</span>
            “Blue Elephant loves Anacott Steel.” Takes crypto to make crypto.
          </div>

          <div className="loyalty-card">
            <img
              alt="landing_imgs"
              src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609936452/cd3d/Group_5237_1_ysc92z.png"
              width="130"
            />
            <span>Wait</span>
            Where patience - and loyalty - is rewarded. Impatience - and fear -
            is punished.
          </div>

          <div className="loyalty-card">
            <img
              alt="landing_imgs"
              src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609936435/cd3d/Group_5168_1_dqauem.png"
              width="130"
            />
            <span>Reinvest</span>
            The only thing better than divs is even MORE divs.
          </div>
        </div>
      </div>

      {/* Feed Us Peanuts */}
      <div className="feedUsPeanuts">
        <span>Feed Us Peanuts</span>

        <div>
          <a target="_blank" href="https://twitter.com/cetoken">
            <img alt="landing_imgs" src={TwitterIcon} />
            Twitter
          </a>

          <a target="_blank" href="https://discord.com/invite/Jxg8GzZ3kq">
            <img alt="landing_imgs" src={DiscordIcon} />
            Discord
          </a>

          <a target="_blank" href="https://t.me/cetoken">
            <img alt="landing_imgs" src={TelegramIcon} />
            Telegram
          </a>
        </div>
      </div>

      {/* Lead the Herd */}
      <div className="leadTheHerd">
        <span>Don’t be the herd, lead the herd</span>

        <div className="leadTheHerd__content">
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Get In
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>Play, or get played.</span>
          </div>
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Kick Back
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>
              It’s all dividends in the end, my friend. Divs never sleep, divs
              know no schedule.
            </span>
          </div>
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Share the wealth
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>
              Don’t let your friends buy gold. Refer them to CETO - for a
              nominal 1/3 fee, of course.
            </span>
          </div>
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Transfer
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>Trade value for value with other CETO tokenholders.</span>
          </div>

          <div className="leadTheHerd__contentRowBlock">
            <span>
              Hold On
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>Hold On for Dear Life.</span>
          </div>
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Increase value
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>Enjoy the unlimited upside of crypto volatility.</span>
          </div>
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Merch
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>
              Really like Crystal Elephant? Get merch from our store using CETO
              - coming soon!
            </span>
          </div>
          <div className="leadTheHerd__contentRowBlock">
            <span>
              Economy
              <img alt="landing_imgs" src={LogoCyan} />
            </span>
            <span>
              Get cool widgets, badges, and buttons that allow other
              tokenholders to pay you in CETO. CETO: Play with it, pay with it.
            </span>
          </div>
          <div className="leadTheHerd__contentRowBlock s">
            <span>
              Sell?
              <img alt="landing_imgs" src={LogoCyan} />
            </span>

            <span className="lastt">
              Pigs get slaughtered but elephants take profits. Enjoy those
              gains… But keep earning divs!
            </span>

            <CinemaDraftButton
              style={{
                background: "#009EE4",
                justifyContent: "center",
                margin: "4rem auto 0",
                zIndex: "99",
              }}
              onClick={() => props.history.replace({ pathname: "/exchange" })}
            >
              Lead the herd
              <img alt="landing_imgs" src={ArrowInButton} width="20px" />
            </CinemaDraftButton>
          </div>
          <div className="leadTheHerd__contentFooter l">
            <span>
              Sell?
              <img alt="landing_imgs" src={LogoCyan} />
            </span>

            <span>
              Pigs get slaughtered but elephants take profits. Enjoy those
              gains… But keep earning divs!
            </span>

            <CinemaDraftButton
              style={{ background: "#009EE4", zIndex: "99" }}
              onClick={() => props.history.replace({ pathname: "/exchange" })}
            >
              Lead the herd
              <img alt="landing_imgs" src={ArrowInButton} width="20px" />
            </CinemaDraftButton>
          </div>

          <span className="leadTheHerd__elephant">
            <img
              alt="landing_imgs"
              src={Elephant}
              width="320px"
              height="320px"
            />
          </span>
        </div>
      </div>

      {/* Ride With Pride */}
      <div className="rideWithPride">
        <span className="upper">Ride with Pride</span>
        <span>
          Proud to be a Crystal Elephant? The Herd is the word as you can buy
          CETO merch exclusively with your tokens from our upcoming online
          store.
        </span>
      </div>

      {/* Q&A */}
      <div className="questionsContainer">
        <span>Rules of the Jungle</span>

        <div className="questionsBlock">
          {questionsArray.map((question, idx) => (
            <React.Fragment key={`QA_${idx}`}>
              <div className="question">
                {question.question}
                {question.isOpen ? (
                  <IconButton onClick={e => toggleQA(e, idx)}>
                    <RemoveCircleIcon style={{ color: " #009EE4" }} />
                  </IconButton>
                ) : (
                  <IconButton onClick={e => toggleQA(e, idx)}>
                    <AddCircleIcon style={{ color: "#691AAA" }} />
                  </IconButton>
                )}
              </div>
              {question.isOpen && (
                <div className="answer">{ReactHtmlParser(question.answer)}</div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <Footer />
    </div>
  );
};

const mapStateToProps = state => {
  console.log(state, "state");
  return {
    currencies: state.utils.currencies,
  };
};

export default connect(mapStateToProps, actions)(Landing);
